import ModelEditor from '@/lib/model-editor.js'
// import store from '@/store.js'
import { store } from '@/shared-store.js'
import schema from '@/schema.js'
import { pluralize } from '@/schema.js'

function apiResourceName(entity) {
	return pluralize(entity.key).replace(/[A-Z]/g, c => `_${c.toLowerCase()}`);
}

class MomentumModelEditor extends ModelEditor {
	
	constructor(obj, entity, delegate) {
		super(obj, entity, delegate);
		this.entity  = entity;
	}
	
	static lookupParticipantRaceEvent(par) {
		
	}
	
	buildBaseURL() {
		let url;
		// store will prepend /api/v1
		url = '/' + apiResourceName(this.entity); // "/race_events";
		
		if (schema.participant == this.entity) {
			// Prepend /race_events/xxx
			let reid = this.workingObj.raceEventId;
			if (!reid) {
				// lookup through race
				let r = store.state.race?.[this.workingObj.raceId];
				reid = r.raceEventId;
			}

			if (!reid) 
				throw new Error('RaceEventMissing');
			
			url = `/race_events/${reid}` + url;
		}

		if (schema.race == this.entity) {
			let reid = this.workingObj.raceEventId;
			if (!reid)
				throw new Error('RaceEventMissing');

			url = `/race_events/${reid}` + url;
		}

		return url;
	}
		
	async commitValues(params) {
		if (!store) {
			throw new Error('Could not save; store missing');
		}

		if (this.changedAttributes.size < 1) {
			// Don't actually send an empty update request
			return;
		}
		
		// Collect changed scalar and relationship attributes as one payload.
		let payload = this.buildPayload();
		
		// Include IDs
		payload.id = this.workingObj.id;
		if (this.workingObj.ephemeralKey)
			payload.ephemeralKey = this.workingObj.ephemeralKey;

		// Determine baseURL
		if (!this.baseURL)
	    this.baseURL = this.buildBaseURL();
		
    // Update the thing
		try {
	      const result = await store.saveEntity({
	        path: this.baseURL,
	        entity: this.entity,
	        object: payload,
	        sourceObject: this.origObj,
	        params
			});
			
			// Update model values with server result
			this.update(result.data);
			super.commitValues();
      return result;
		}
		catch (e) {
			console.error("Could not upload values", e);
			throw e;
		}
	}
}

export function createModelProxy(obj, entity, delegate) {
  let handler = new MomentumModelEditor(obj, entity, delegate);
  let proxy = new Proxy(obj, handler);
  
  return proxy;
}
